const DEFAULT_TITLE =
  "Pollen - Formation professionnelle et continue avec les meilleurs experts";

export function useSeoContentRegistry() {
  return useLazyFetch("/api/seo-content", {
    default: () => [],
  });
}

export function useSeoContentMatch() {
  const route = useRoute();

  const { data } = useSeoContentRegistry();

  return computed(() => {
    return data.value.find((content) =>
      isMatchingPath(route.path, content.path),
    );
  });
}

export function useSeoContentRoot() {
  const { $host } = useNuxtApp();
  const match = useSeoContentMatch();
  const { t } = useI18n();

  const title = computed(() => {
    return match.value?.document_title;
  });

  const description = computed(
    () =>
      match.value?.document_metadescription ||
      t("app.seo.default_metadescription"),
  );

  useSeoMeta({
    titleTemplate(titleChunk) {
      const prefix = title.value || titleChunk;

      return prefix ? `${prefix} - ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    },
    description,
    ogType: "website",
    ogSiteName: "Pollen",
    ogImage: `${$host}/images/brand/og-image.jpg`,
    twitterSite: "@hey_pollen",
  });

  useSchemaOrg([
    defineOrganization({
      name: "Pollen",
      logo: "/images/logo_full_color.svg",
    }),
    defineWebPage(),
  ]);
}
